var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCommunicationSuccessImage = function SvgCommunicationSuccessImage(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9767_10422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.247 112.177C124.575 113.958 121.139 114.124 118.307 112.609C115.476 111.094 113.708 108.143 113.708 104.931V96.2227H105C90.5712 96.2227 78.875 84.5261 78.875 70.0977V43.9727C78.875 29.5443 90.5712 17.8477 105 17.8477H165.958C180.387 17.8477 192.083 29.5443 192.083 43.9727V70.0977C192.083 84.5261 180.387 96.2227 165.958 96.2227H151.179L127.247 112.177Z",
    fill: "#E7E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4499 104.933C47.0215 104.933 35.3249 116.629 35.3249 131.058C35.3249 136.427 36.9442 141.417 39.721 145.567C26.6832 153.09 17.9082 167.174 17.9082 183.308C17.9082 188.118 21.8071 192.016 26.6165 192.016H96.2832C101.093 192.016 104.992 188.118 104.992 183.308C104.992 167.174 96.2161 153.09 83.1787 145.567C85.9556 141.417 87.5749 136.427 87.5749 131.058C87.5749 116.629 75.8783 104.933 61.4499 104.933Z",
    fill: "#E7E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 42.8862H170.312",
    stroke: "#B5B5C3",
    strokeWidth: 6.53125,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 59.2144H170.312",
    stroke: "#B5B5C3",
    strokeWidth: 6.53125,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.062 72.2769H157.25",
    stroke: "#B5B5C3",
    strokeWidth: 6.53125,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 157.185,
    r: 49.0909,
    fill: "#2555EF",
    stroke: "white",
    strokeWidth: 9.81818
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.786 166.583L143.191 154.614L137.955 159.85L154.786 177.055L190.319 141.149L185.082 135.913L154.786 166.583Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9767_10422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 209,
    fill: "white",
    transform: "translate(0.5 0.433105)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommunicationSuccessImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/communicationSuccessImage.1d00f63f.svg";
export { ForwardRef as ReactComponent };